import { render, staticRenderFns } from "./kgriditem.vue?vue&type=template&id=5ab237b2&scoped=true"
import script from "./kgriditem.vue?vue&type=script&lang=js"
export * from "./kgriditem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab237b2",
  null
  
)

export default component.exports